module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/product/product.component.css
// module id = ./src/app/components/product/product.component.css
// module chunks = main